




















































































import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import SignUpFirst from '@/components/gambling/SignUpFirst.vue'
import gameOneIcon from '@/assets/game1.png'
import gameTwoIcon from '@/assets/game2.png'
import gameThreeIcon from '@/assets/game3.png'
import Roulette from '@/components/gambling/Games/Roulette.vue'

@Component({
  components: {
    SignUpFirst,
    Roulette
  },
  computed: {
    ...mapState({
      isAuthenticated: ({ gamblingContext }: any): boolean => gamblingContext.isAuthenticated,
      fullName: ({ gamblingContext }: any): null | string => gamblingContext.credentials.username
    })
  }
})

export default class GamblingCasino extends Vue {
  private startRoulette: boolean = false
  private cards: object[] = [
      { src: gameOneIcon },
      { src: gameTwoIcon },
      { src: gameThreeIcon }
    ]

  private playRoulette (): void {
    this.startRoulette = true
  }
}
